import React from 'react';
import styles from './css/PlanningSearchCTA.styl';
import appConfig from '../../../../../appConfig/AppConfig';
import sharedStyles from '../../css/Shared.styl';
import Button from '../../../../shared/library/Button/Button';

const planningImg = require('../../assets/planning-laptop-phone.png');

const PlanningSearchCTA = () => (
  <div className={styles.PlanningSearchCTA}>
    <div className={sharedStyles.Wrap}>
      <div className={styles.PlanningCTABlock}>
        <div className={styles.ContentContainer}>
          <h2 className={styles.Title}>
            Ready to contact a funeral&nbsp;home?
          </h2>
          <div className={styles.Blurb}>
            Once you've gathered your preferences, discuss them with a local
            funeral&nbsp;director.
          </div>
          <Button
            href={`${appConfig().vanityDomain}/funeral-homes`}
            target="_blank"
            className={`${styles.Button} button btn large-button primary`}
          >
            Search Now
          </Button>
        </div>
        <div className={styles.ImgContainer}>
          <img src={planningImg} />
        </div>
      </div>
    </div>
  </div>
);

export default PlanningSearchCTA;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/PlanningSearchCTA/index.js